export default __webpack_public_path__ + "static/media/LogoOficial.638ed21f.png";